import { Chip, Tooltip } from "@mui/material";
import { formatCommentTimestamp } from "../brief/briefUiUtils";

// The brand's call on a plan creator, made from the "Share with brand" link.
// `approval` is the row's brandApproval ({decision, note, by, at}) — null = pending.
// Keys mirror BRAND_DECISIONS in pluginbackendnode/models/plan.js.
export const BRAND_APPROVAL_META = {
  approved: { label: "Approved", bg: "#D1FAE5", color: "#065F46" },
  rejected: { label: "Rejected", bg: "#FEE2E2", color: "#991B1B" },
  pending: { label: "Pending", bg: "#F3F4F6", color: "#4B5563" },
};

export const brandDecisionOf = (approval) => approval?.decision || "pending";

const BrandApprovalChip = ({ approval }) => {
  const meta = BRAND_APPROVAL_META[brandDecisionOf(approval)];
  const detail = approval
    ? `${meta.label} by ${approval.by || "Brand"}, ${formatCommentTimestamp(approval.at)}${approval.note ? ` — "${approval.note}"` : ""}`
    : "The brand hasn't decided yet";
  return (
    <Tooltip title={detail} arrow>
      <Chip size="small" label={meta.label} sx={{ bgcolor: meta.bg, color: meta.color, fontWeight: 600, fontSize: 12 }} />
    </Tooltip>
  );
};

export default BrandApprovalChip;
